import moment from 'moment';
import 'moment/locale/id';

export const datePipe = (value: number): string => {
	if (value !== 0) {
		const date = new Date(value * 1000);
		moment.locale('id');
		const res = moment(date).format('LL');
		return res;
	}
	return '-';
};

export default datePipe;
